<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Permissions/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Administración de Permisos por Usuario</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="addPermission">Agregar</v-btn>
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="permissions"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.description }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          color="blue"
                          class="mr-2"
                          @click="editItem(props.item)"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          color="red"
                          @click="deleteItem(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
                    </template>
                    <!-- <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Limpiar</v-btn>
                    </template> -->

                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Permisos</v-card-title>

            <v-card-text>
              Mantenimiento de la tabla de PermissionUsers del sistema para gestionar el acceso a las funcionalidades del mismo.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
<!-- Fin de dialogo -->

    <!-- dialog para form permissions -->
    <v-dialog v-model="dialog" width="600">
      <FormPermission :tipo="tipo" :datos="getPermissions" v-on:closeDialogPermission="closeDialogPermission($event)" />
    </v-dialog>
    <!-- fin dialog form permissions -->

    </v-layout>
</template>

<script>
import axios from 'axios'
import FormPermission from '~/components/form/formPermission.vue'

  export default {
    name: "admin-permissions-view",

    components: {
      FormPermission
    },

    data: () => ({
      dialog: false,
      nota: {nombre: '', descripcion: ''},
      helpdialog: false,
      loading: false,
      total: 0,
      tipo: '',
      search: '',
      pagination: {},
      headers: [
        { text: 'Nombre', align: 'left', sortable: false, value: 'name' },
        { text: 'Descripción', align: 'left', sortable: false, value: 'description' },
        { text: 'Acciones', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      permissions: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        description: ''
      },
      defaultItem: {
        name: '',
        description: ''
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Registrar nuevo Rol' : 'Editar Rol'
      },
      getPermissions () {
          return this.editedItem
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination() {
        this.getPermissionByPagination();
      }
    },

    methods: {

      editItem (item) {
        this.tipo = "editar"
        this.editedIndex = this.permissions.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      addPermission () {
        this.tipo = "crear"
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.permissions.indexOf(item)
        let confirmDelete =  confirm(`se eliminará el PERMISO:  ${item.name}, está seguro?`) && this.permissions.splice(index, 1)
        if(confirmDelete){
        axios.delete(`/api/permissions/admin/${item.id}`)
          .then(()=>{
            this.permissions.splice(index, 1);
          })
          .catch(error => {
              console.log(error.response);
            });
      }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) { // update
          let formData = new FormData();
          for (var key in this.editedItem) {
            formData.append(key, this.editedItem[key]);
          }
          console.log(this.editedItem,'aa')
          formData.set('_method', 'patch')
          axios.post(`/api/permissions/admin/update_permission`, formData)
          .then((resp) => {
            this.search = resp.data.name
            this.getPermissionByPagination();
          })
          .catch(error => {
              console.log(error.response);
          });

        } else { // create
          this.submitFormPermissions()
        }
        this.close()
      },

      async submitFormPermissions () {
        axios.post(`/api/permissions/admin/create_permission`, this.editedItem)
          .then((resp) => {
            this.search = resp.data.name
            this.getPermissionByPagination();
            //this.permissions.push(resp.data)
          })
          .catch(error => {
              console.log(error.response);
          });
      },

      async getPermissionByPagination() {
            this.loading = true;
            if (this.search) {
                await axios.get(`/api/administration/permissions/permissions-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        console.log(res, 'data')
                        this.permissions = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                await axios.get(`/api/administration/permissions/permissions-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        console.log(res, 'data')
                        this.loading = false;
                        this.permissions = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                await axios.get(`/api/administration/permissions?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        console.log(res, 'data')
                        this.permissions = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        onChange () {
            this.getPermissionByPagination();
        },

        closeDialogPermission (response) {
          if (response != null) {
            var item = this.permissions.find(permissions => permissions.id === response.id)
            if (this.tipo == 'crear') {
              this.permissions.push(response)
            }else {
              Object.assign(item, response)
            }
            this.search = response.name
            this.getPermissionByPagination();
          }
          this.dialog = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/permissionUser.vue